import {createAction} from 'redux-actions';
import httpRequestPromise from 'app/httpRequestPromise';
import * as actionsTypes from 'app/constants/AppConstants';
import {KINOKASSA_API_URL} from 'app/constants/SettingsConstants';

const setDailySeancesIsFetching = createAction(
	actionsTypes.SET_DAILY_SEANCES_IS_FETCHING,
);

const setDailySeances = createAction(
	actionsTypes.SET_DAILY_SEANCES,
	payload => (payload),
);

export const setDailySeancesError = createAction(
	actionsTypes.SET_DAILY_SEANCES_ERROR,
	payload => (payload),
);

const getDailySeancesFail = createAction(
	actionsTypes.GET_DAILY_SEANCES_FAIL,
	(code) => ({code}),
);

const getDailySeancesRequest = (date, cityId, cinemaId) => async (dispatch) => {
	dispatch(setDailySeancesIsFetching());

	try {
		if (cityId && date) {
			const requestUrl = new URL('/api/v2/release/playbill/flatten', KINOKASSA_API_URL);

			requestUrl.searchParams.append('city_id', `${cityId}`);
			requestUrl.searchParams.append('date', date);
			// eslint-disable-next-line no-unused-expressions
			cinemaId && requestUrl.searchParams.append('cinema_id', cinemaId);

			const {seances, releases} = await httpRequestPromise(requestUrl, 'GET');

			const data = {
				dailySeances: seances,
				dailyReleases: _.map(releases, release => _.pick(release, ['age_rating', 'id', 'title', 'genres', 'rambler_id']))
			};

			dispatch(setDailySeances(data));
		}
	} catch (error) {
		dispatch(getDailySeancesFail(actionsTypes.INTERNAL_SERVICE_ERROR));
	}
};

export default getDailySeancesRequest;
